import React from 'react'
import styles from './IconSlot.module.scss'

interface IconSlotProps {
  children: React.ReactNode
  className?: never
}

export const IconSlot: React.FC<IconSlotProps> = ({ children }) => (
  <span className={styles.slot}>{children}</span>
)
